import * as React from 'react';
import { FluidSection } from '../../../components/FluidSection/FluidSection';
import FlatButton from 'material-ui/FlatButton';
import { Calendar } from '../../../components/Calendar/Calendar';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import { Content } from '../../../components/Content/Content';

// interface ComponentProps extends React.Props<any> {
//     onChangeViewIndex?: any;
//     service?: any;
//     setBookingData?: any;
//     style?: any;
// }

// declare global {
//     namespace JSX {
//         interface IntrinsicElements {
//             onChangeViewIndex: any
//         }
//     }
// }

class BookingSelectionView extends React.Component/*<ComponentProps, {}>*/ {
    render(){
        const { headerSectionContainerStyles, headerSectionContentStyles, backButtonContainerStyles, backButtonStyles } = styles;
        return (
            <div>
                <FluidSection style={ headerSectionContainerStyles }>
                    <Content 
                        style={ headerSectionContentStyles } 
                        mainTitleText={`Booking Calendar`} 
                        bodyText={` Click on an available timeslot to book a consultation. Use the 'Next' and 'Previous' buttons to see more available booking times.`}
                    />
                </FluidSection>
                
                <FluidSection
                    style={ backButtonContainerStyles }
                >
                    <FlatButton
                        style={ backButtonStyles }
                        label="BACK TO SERVICE DETAILS"
                        primary={true}
                        onClick={() => this.props.onChangeViewIndex(0)}
                        disableTouchRipple={true}
                        disableFocusRipple={true}
                        icon={<ArrowLeft />}
                    />
                </FluidSection>

                <Calendar
                    onChangeViewIndex={this.props.onChangeViewIndex}
                    selectedService={this.props.service}
                    setBookingData={ this.props.setBookingData }
                />
            </div>
        );
    }
}


const styles = {
    headerSectionContainerStyles: {
        marginTop: 40,
        marginBottom: -20
    },
    headerSectionContentStyles: {
        marginmarginBottom: 40, 
        marginRight: 40
    },
    backButtonContainerStyles: {
        marginTop: -170
    },
    backButtonStyles: {
        marginLeft: 0, 
        position: 'absolute', 
        top: 50, 
        display: 'block', 
        marginBottom: -50, 
        width: 255
    }
}
export default BookingSelectionView;


// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceSalesFlow/BookingSelectionView.jsx